import "./Playerdetail.css";
import ffc from "../../teamImage/ffc.png";
import manU from "../../teamImage/manU.png";
import she from "../../teamImage/she.png";
import kelvin from "../../teamImage/kelvin.jpg";
import { NavLink } from "react-router-dom";
import backArrow from "../../../../images/arrow.png";
      import whiteArrow from "../../../../images/white-arrow.png";

const Playerdetail = ({dark}) => {
    return <div className="playerdetailWrapper" style={dark ? {backgroundColor: "#111111e7"} : {}}>
        
      <NavLink className="strong" to="/teams/details" style={{ cursor: "pointer" }}>
        ←
      </NavLink>
        
        <section className="firstsection">
            <nav>
                <img src={kelvin} alt="" />
                <div>
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>Kelvin Williams</p>
                    <strong style={dark ? {color: "#e2e1e1ff"} : {color: "#3F3E3E"}}>22 years,  England</strong>
                    <strong style={dark ? {color: "#e2e1e1ff"} : {color: "#3F3E3E"}}>Manchester city</strong>
                </div>
            </nav>
            <menu>
                <ul style={dark ? {backgroundColor: "#131313ff"} : {}}>
                    <li><NavLink to="/teams/players" className="linkname"
                     style={dark ? {color: "#fafafaff"} : {color: "#3F3E3E"}}>Overview</NavLink></li>
                    <li><NavLink to="/teams/player/news" className="linkname"
                     style={dark ? {color: "#fafafaff"} : {color: "#3F3E3E"}}>News</NavLink></li>
                    <li><NavLink to="/teams/player/statistics" className="linkname"
                     style={dark ? {color: "#fafafaff"} : {color: "#3F3E3E"}}>Statistics</NavLink></li>
                </ul>
            </menu>
        </section>


        <section className="secondsection">
            <h1 className="h1" style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>Basic Information</h1>
            <nav>
                <span style={dark ? {color: "#fafafaff"} : {}}><strong style={{color: "#249224"}}>Height:</strong> 1.78m ( 5 FT 10 in)</span>
                <span style={dark ? {color: "#fafafaff"} : {}}><strong style={{color: "#AD2E2E"}}>Weigh:</strong> 75Kg (165lbs)</span>
            </nav>
            <nav>
                <span style={dark ? {color: "#fafafaff"} : {}}><strong style={{color: "#93931A"}}>Jersey nymber:</strong> 10</span>
                <span style={dark ? {color: "#fafafaff"} : {}}><strong style={{color: "#4497C0"}}>Position:</strong> Forward</span>
            </nav>
            <h1 className="h1" style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>Biography</h1>
            <p style={dark ? {color: "#dfdfdfff"} : {color: "#141414ff"}}>Watch your favorite team compete in real-time. Tune in now and experience the thrill of
                 Saudi football - live, Watch your favorite team compete in real-time. Tune in now and 
                 experience Watch your favorite team compete in real-time. Tune in now and experience 
                 the. Watch your favorite team compete in real-time. Tune in now and experience the 
                 thrill of Saudi football - live, Watch your favorite team compete in real-time. Tune 
                 in now and experience Watch your favorite team compete in real-time. Tune in now and 
                 experience th</p>
        </section>


        <section className="thirdsection">
            <h1 style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>Current form ( last 6 matches )</h1>
            <div>
                <nav style={dark ? {backgroundColor: "#131313ff"} : {}}>
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>PL (MW2)</p>
                    <img src={she} alt="" />
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>SHE (A)</p>
                    <span>
                        <h4 style={{backgroundColor: "red"}}>2-0</h4>
                        <h5>7.8 Rating</h5>
                    </span>
                </nav>
                
                <nav style={dark ? {backgroundColor: "#131313ff"} : {}}>
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>PL (MW2)</p>
                    <img src={she} alt="" />
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>SHE (A)</p>
                    <span>
                        <h4 style={{backgroundColor: "red"}}>2-0</h4>
                        <h5>7.8 Rating</h5>
                    </span>
                </nav>
                
                <nav style={dark ? {backgroundColor: "#131313ff"} : {}}>
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>PL (MW2)</p>
                    <img src={she} alt="" />
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>SHE (A)</p>
                    <span>
                        <h4 style={{backgroundColor: "red"}}>2-0</h4>
                        <h5>7.8 Rating</h5>
                    </span>
                </nav>
                
                <nav style={dark ? {backgroundColor: "#131313ff"} : {}}>
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>PL (MW2)</p>
                    <img src={she} alt="" />
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>SHE (A)</p>
                    <span>
                        <h4 style={{backgroundColor: "red"}}>2-0</h4>
                        <h5>7.8 Rating</h5>
                    </span>
                </nav>
                
                <nav style={dark ? {backgroundColor: "#131313ff"} : {}}>
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>PL (MW2)</p>
                    <img src={she} alt="" />
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>SHE (A)</p>
                    <span>
                        <h4 style={{backgroundColor: "red"}}>2-0</h4>
                        <h5>7.8 Rating</h5>
                    </span>
                </nav>
                
                <nav style={dark ? {backgroundColor: "#131313ff"} : {}}>
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>PL (MW2)</p>
                    <img src={she} alt="" />
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>SHE (A)</p>
                    <span>
                        <h4 style={{backgroundColor: "red"}}>2-0</h4>
                        <h5>7.8 Rating</h5>
                    </span>
                </nav>
                
            </div>
        </section>

        <section className="fourthsection">
            <div>
                <h1 style={dark ? {color: "#fafafaff"} : {}}>highlighted news from the club</h1>

                <nav style={dark ? {backgroundColor: "#0a0a0aff"} : {}}>
                    <img style={dark ? {backgroundColor: "#1d1d1dff"} : {}} src="" alt="0" />
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819e7"}}>Watch your favorite team compete in real-time. Tune in now and experience the 
                        thrill of Saudi football - live, Watch your favorite team compete in real-time.
                         Tune in now and experience Watch your favorite team compete in real-time. Tune
                          in now and experience th</p>
                </nav>
            </div>
        </section>

    </div>
}

export default  Playerdetail;